/* eslint-disable */
import mixin from './_mixin_display_base'
export default {
  mixins: [mixin],
}